import { ENABLE_STAGING_SETTING } from '@src/constants';

export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获得手机号验证码
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/cbsubscribe231024/get_phone_code?phone=15913351519

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "1FgDfGnYqhBqq8HfPpp27n1281halWQn7Eue11SI",
	        "request_id": "f95286331d81cb00b8192b96dec2364ce3554728"
	    }
	 }
		*/
  service.getPhoneCode = function({ phone, type, ...params }) {
    return request
      .jsonp(rootAddress + '/webapp/cbsubscribe231024/get_phone_code', {
        phone: phone /*  手机号 */,
        type: type /*  验证码类型（1：查询测试资格验证码，3：测试招募获得验证码，4：官网预约） */,
        ...params
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10308",
        "description": "短信验证码发送数量达到每日上限"
      }, {
        "code": "-10309",
        "description": "短信验证码发送频率太快"
      }, {
        "code": "-10316",
        "description": "参数缺失"
      }, {
        "code": "-10317",
        "description": "参数类型错误"
      }, {
        "code": "-10601",
        "description": "图片验证码为空"
      }, {
        "code": "-10602",
        "description": "图片验证码错误"
      }, {
        "code": "-10603",
        "description": "极验验证失败"
      }, {
        "code": "-10604",
        "description": "图片验证码参数错误"
      }, {
        "code": "-10605",
        "description": "图片验证码已过期，请重新刷新"
      }, {
        "code": "-10606",
        "description": "顶象验证失败"
      }, {
        "code": "-12304",
        "description": "手机号OpenId参数缺失"
      }, {
        "code": "-20103",
        "description": "该手机号已预约"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		预约
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/cbsubscribe231024/subscribe?phone=15913351516&code=123123&utm_source=sem&from=fab

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "1FgDfGnYqhBqq8HfPpp27n1281halWQn7Eue11SI",
	        "request_id": "2adea4796261580907e068582b92958dc24fcb8f"
	    }
	 }
		*/
  service.subscribe = function(code, from, phone, utm_source) {
    return request
      .jsonp(rootAddress + '/webapp/cbsubscribe231024/subscribe', {
        code: code /*  手机验证码 */,
        from: from /*  预约来源(default：官方， fab：fab页) */,
        phone: phone /*  手机号 */,
        utm_source: utm_source /*  utm来源 */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-10315",
        "description": "短信验证码已经被验证过，请重新获取"
      }, {
        "code": "-20103",
        "description": "该手机号已预约"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		退出登录
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/cbsubscribe231024/logout

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "riRirWogbUtsC3rpoyrr4Q5LWKQh9numgwQwoprj",
	        "request_id": "5d78e9530b508d24bbd408d313de33dbeaf98847"
	    }
	 }
		*/
  service.logout = function() {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/logout', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20104",
        "description": "当前账号未登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得官网基础信息
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/cbsubscribe231024/gw_config

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "open_down_load": 0,
	        "login_account": "",
          "is_in_subscribe_code_time": 0,
	        "session_id": "Th00Ug3m6SCy7mRWtnXgHqcuSkpog5AWjCYIgspY",
	        "request_id": "6acb702656748962ff11123df3cee640607cb131"
	    }
	 }
		*/
  service.gwConfig = function() {
    return request.jsonp('https://mechabreak.seasungames.cn/webapp/mbsubscribe231101/gw_config').then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "login_account": "登录账号/手机号（open_down_load为1是通行证，为0是手机号）",
            "is_in_subscribe_code_time": 0, (预约阶段是否发放福利吗)
            "open_down_load": "是否开启游戏下载（1：是，0：否）",
            "down_load_get_code_status": "下载阶段是否开启福利码领取（1：是，0：否）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20104",
        "description": "当前账号未登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		官网预约
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/cbsubscribe231024/subscribe_by_gw?phone=1831609841&code=123123

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_first": 1,
	        "session_id": "Th00Ug3m6SCy7mRWtnXgHqcuSkpog5AWjCYIgspY",
	        "request_id": "5a49189d94d026fcbd0060d6982b5bf5b53546f2"
	    }
	 }
		*/
  service.subscribeByGw = function({ phone, code, utm_source }) {
    return request
      .jsonp(rootAddress + '/webapp/cbsubscribe231024/subscribe_by_gw', {
        phone: phone /*  手机号 */,
        code: code /*  手机号验证码（get_phone_code接口，参数type需传4） */,
        utm_source: utm_source /*  utm来源 */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "is_first": "是否首次预约（1：是，0：否）"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-10315",
        "description": "短信验证码已经被验证过，请重新获取"
      }, {
        "code": "-20103",
        "description": "该手机号已预约"
      }, {
        "code": "-20104",
        "description": "当前账号未登录"
      }, {
        "code": "-20115",
        "description": "您已登录，请先退出"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		获得预约福利码
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/cbsubscribe231024/get_code_in_subscribe

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "code": "dd675ddd4c04519330c4f677174d1ca0",
	        "session_id": "Th00Ug3m6SCy7mRWtnXgHqcuSkpog5AWjCYIgspY",
	        "request_id": "2954fb6f71d51411ba4799af81326a706d2a1548"
	    }
	 }
		*/
  service.getCodeInSubscribe = function(utm_source, from = 'gc_gw') {
    const params = { utm_source, from };
    // 是否开启灰度环境配置
    if (ENABLE_STAGING_SETTING) {
      params.is_huidu = 'huidu_test';
    }
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/get_code_in_subscribe', params).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "code": "福利码"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20104",
        "description": "当前账号未登录"
      }, {
        "code": "-20113",
        "description": "当前不在预约时间范围内"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得公测下载福利码
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/cbsubscribe231024/get_code_in_down_load

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "code": "42baa860bf7d83e36b65e534e33c2c71",
	        "session_id": "Th00Ug3m6SCy7mRWtnXgHqcuSkpog5AWjCYIgspY",
	        "request_id": "3b6598018ea2fcec5184d6e658b86d41641511ff"
	    }
	 }
		*/
  service.getCodeInDownLoad = function(utm_source, from = 'gc_gw') {
    const params = { utm_source, from };
    // 是否开启灰度环境配置
    if (ENABLE_STAGING_SETTING) {
      params.is_huidu = 'huidu_test';
    }
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/get_code_in_down_load', params).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "code": "福利码"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20114",
        "description": "当前不在下载时间范围内"
      }, {
        "code": "-20116",
        "description": "当前不可领取福利码"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		首页预约 - 预约
		请求方法: GET, POST
		请求示例:
	  响应示例:
		*/
  service.index_subscribe = function(params) {
    return request
      .jsonp(rootAddress + '/webapp/cbsubscribe231024/subscribe', {
        /*
        code	手机验证码
        from	预约来源(default：官方， fab：fab页)
        phone	手机号
        utm_source	utm来源
        */
        ...params,
        from: 'default'
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "code": 1,
          "status": 1,
          "msg": "",
          "message": "",
          "data": {
              "qualification": 0,
              "down_load_url": "",
              "session_id": "haw2O7aLMjTygKgziYNHxOAqMsCi8AJKqNfX5MpG",
              "request_id": "0bdb65e36554476ec1f703c5fd536ad81feddf40"
          }
        }
        		*/
          return response.data;
        }
        return reject(response);
      });
  };
  return service;
}
